var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group page-type-group", attrs: { role: "group" } },
    [
      !_vm.noTitle ? _c("h3", [_vm._v(_vm._s(_vm.label))]) : _vm._e(),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.description))]),
      _vm._v(" "),
      _vm._l(_vm.options, function(option) {
        return _c(
          "div",
          {
            key: option.id,
            class: ["checkbox-detailed", _vm.disabled ? "disabled" : ""]
          },
          [
            option.image
              ? _c("img", {
                  staticClass: "template-img",
                  attrs: { src: option.image }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("input", {
              class: [_vm.disabled ? "disabled" : ""],
              attrs: {
                type: _vm.multiple ? "checkbox" : "radio",
                name: _vm.getInputKey(0),
                id: _vm.getInputKey(option)
              },
              domProps: { checked: _vm.currentValue == option.id },
              on: {
                input: function($event) {
                  return _vm.onUpdate(option)
                }
              }
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                class: [option.image ? "checkbox-has-image" : ""],
                attrs: { for: _vm.getInputKey(option) }
              },
              [
                _c("span", { staticClass: "checkbox-detailed-tbl" }, [
                  _c("span", { staticClass: "checkbox-detailed-cell" }, [
                    option.name
                      ? _c(
                          "div",
                          { staticClass: "col-form-label template-label" },
                          [_vm._v(_vm._s(_vm.__(option.name, ["titleCase"])))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "checkbox-detailed-desc" }, [
                      _vm._v(_vm._s(option.description))
                    ])
                  ])
                ])
              ]
            )
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31798b48", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31798b48","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/form-elements/RadioListComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-31798b48","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/form-elements/RadioListComponent.vue
// module chunks = 0